<template>
  <a-select
    v-bind="$attrs"
    v-on="$attrs"
    :value="selectValue"
    @input="emitValue"
    :allowClear="allowClear"
    :getPopupContainer="getPopupContainer"
    :placeholder="placeholder"
    :dropdownMenuStyle="dropdownMenuStyle"
    :mode="mode"
  >
    <a-select-option
      v-for="item in optionList"
      :key="item[optionValue]"
      :value="item[optionValue]"
    >
      {{ item[optionLabel] }}
    </a-select-option>
  </a-select>
</template>

<script>
import { getSelect } from "@/plugins/select-option/util";

export default {
  name: "z-select",
  props: {
    value: {
      type: [String, Number, Array],
      default: undefined,
    },
    optionName: {
      type: [String, Object],
      default: "",
    },
    options: {
      type: Array,
      default: () => [],
    },
    optionLabel: {
      type: String,
      default: "label",
    },
    optionValue: {
      type: String,
      default: "value",
    },
    placeholder: {
      type: String,
      default: "请选择",
    },
    allowClear: {
      type: Boolean,
      default: true,
    },
    autoValue: {
      type: Boolean,
      default: false,
    },
    dropdownMenuStyle: {
      type: Object,
      default: () => ({ maxHeight: "300px" }),
    },
    getPopupContainer: {
      type: Function,
      default: (triggerNode) => triggerNode.parentNode,
    },
    mode: {
      type: String,
      default: "default",
    },
  },
  data() {
    return {
      optionList: [],
      timer: null,
    };
  },
  computed: {
    selectValue() {
      return this.value === null || this.value === "" ? undefined : this.value;
    },
  },
  created() {
    this.changeOptionList();
  },
  methods: {
    emitValue(val) {
      this.$emit("input", this.mode === "multiple" ? [val] : val);
    },
    resetToFirst() {
      if (this.optionList.length > 0) {
        this.emitValue(this.optionList[0][this.optionValue]);
      }
    },
    async changeOptionList() {
      try {
        let list = [];
        if (this.optionName) {
          list = [...(await getSelect(this.optionName))];
        }
        this.optionList = [...this.options, ...list];
        if (this.autoValue && this.optionList.length) {
          this.resetToFirst();
        }
        this.$emit("initOptions", this.optionList);
      } catch (error) {
        this.$emit("initOptions", this.optionList);
      }
    },
  },
  watch: {
    options() {
      this.changeOptionList();
    },
  },
};
</script>

<style lang="scss" scoped>
.ant-select {
  min-width: 150px;
}
</style>
